const STORAGE_KEY = 'goMorgen_submittedAt';
const COOLDOWN_MS = 24 * 60 * 60 * 1000; // 1 day
// const COOLDOWN_MS = 45 * 1000; // 45 seconds

const drawSection = {
   form: document.getElementById('section-draw-form'),
   poll: document.getElementById('section-draw-poll'),
}

const register = {
   form: document.getElementById('draw-form'),
   fullName: document.getElementById('draw-full-name'),
   phone: document.getElementById('draw-phone'),
   email: document.getElementById('draw-email'),
   address: {
      street: document.getElementById('draw-streetname'),
      postalCode: document.getElementById('draw-postal-code'),
      postOffice: document.getElementById('draw-post-office'),
   },
   submit: document.getElementById('draw-submit'),
};

const submit = {
   container: document.querySelector('.submit-message'),
   success: document.getElementById('submit-success'),
   error: document.getElementById('submit-error'),
}

function isWithinCooldown() {
   const submittedAt = localStorage.getItem(STORAGE_KEY);
   if (!submittedAt) return false;
   return Date.now() - parseInt(submittedAt, 10) < COOLDOWN_MS;
}

function markSubmitted() {
   localStorage.setItem(STORAGE_KEY, Date.now().toString());
}

// wait for HTML to load before manipulating DOM
document.addEventListener('DOMContentLoaded', () => {

   // apply submitted state if within cooldown
   if (isWithinCooldown()) {
      submit.container.classList.remove('hidden');
      submit.success.classList.remove('hidden');
      submit.error.classList.add('hidden');
      register.form.remove(); // remove HTML completely
      drawSection.poll.classList.remove('hidden');
   }

   // form
   if (register.submit) {
      register.submit.addEventListener('click', (event) => {
         // HTML validation
         if (register.form.checkValidity()) {
            event.preventDefault();

            if (isWithinCooldown()) {
               return;
            }

            const bodyParams = new URLSearchParams({
               table: 'GoMorgenTrekning',
               campaign: 'premietrekning',
               fullName: register.fullName.value,
               phone: register.phone.value,
               address: `${register.address.street.value}, ${register.address.postalCode.value} ${register.address.postOffice.value}`,
               email: register.email.value,
            });

            fetch('/_/service/no.tine.tine/entrySave', {
               method: 'POST',
               headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
               body: bodyParams,
            })
            .then((response) => {
               submit.container.classList.remove('hidden');

               if (response.status.toString().startsWith('2')) {
                  // success
                  markSubmitted();
                  submit.success.classList.remove('hidden');
                  submit.error.classList.add('hidden');

                  register.form.classList.add('hidden');
                  drawSection.poll.classList.remove('hidden');
               } else {
                  // error
                  submit.success.classList.add('hidden');
                  submit.error.classList.remove('hidden');

                  console.error('-------- error --------');
                  console.error(response);
               }
            })
            .catch((error) => {
               console.error('-------- error --------');
               console.error(error);

               submit.container.classList.remove('hidden');
               submit.error.classList.remove('hidden');
               register.form.classList.add('hidden');
               submit.success.classList.add('hidden');
            });
         }
      });
   } else {
      console.info('No submit button defined');
   }
   
});
